import { render, staticRenderFns } from "./UploadRequestDocumentPreference.vue?vue&type=template&id=4ba3f48f"
import script from "./UploadRequestDocumentPreference.vue?vue&type=script&lang=js"
export * from "./UploadRequestDocumentPreference.vue?vue&type=script&lang=js"
import style0 from "./UploadRequestDocumentPreference.vue?vue&type=style&index=0&id=4ba3f48f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports